export const PLAY_FULL_SCREEN_VIDEO = "PLAY_FULL_SCREEN_VIDEO";
export const CLOSE_FULL_SCREEN_VIDEO = "CLOSE_FULL_SCREEN_VIDEO";
export const SET_PLAYING_FULL_SCREEN = "SET_PLAYING_FULL_SCREEN";
export const VIDEO_MODE_FULLSCREEN = "VIDEO_MODE_FULLSCREEN";
export const VIDEO_MODE_INLINE = "VIDEO_MODE_INLINE";
export const VIDEO_MODE_MINIPLAYER = "VIDEO_MODE_MINIPLAYER";
export const PLAY_IN_MINI_PLAYER = "PLAY_IN_MINI_PLAYER";
export const CLOSE_MINI_PLAYER = "CLOSE_MINI_PLAYER";
